var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreeGroupFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 53,
    viewBox: "0 0 176 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 41.5,
    cy: 22.5,
    r: 22.5,
    fill: "#00B288"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 13.5,
    cy: 34.5,
    r: 13.5,
    fill: "#00B288"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 41.5,
    y1: 14.5,
    x2: 41.5,
    y2: 52.5,
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.7071,
    y1: 32.8496,
    x2: 41,
    y2: 41.1425,
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 12.2279,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 51 22)",
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 13.6133,
    y1: 29.9531,
    x2: 13.6133,
    y2: 52.5003,
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.38679,
    y1: 40.834,
    x2: 13.1137,
    y2: 45.5608,
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 7.18478,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 19.1514 34.2832)",
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    r: 22.5,
    transform: "matrix(-1 0 0 1 112.5 22.5)",
    fill: "#00B288"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    r: 13.5,
    transform: "matrix(-1 0 0 1 140.5 34.5)",
    fill: "#00B288"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    r: 13.5,
    transform: "matrix(-1 0 0 1 162.5 34.5)",
    fill: "#00B288"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    r: 13.5,
    transform: "matrix(-1 0 0 1 84.5 34.5)",
    fill: "#00B288"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 38.5,
    y2: -0.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 113 14)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 12.2279,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 122 32.8496)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.707,
    y1: 22,
    x2: 112,
    y2: 30.2929,
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.0472,
    y2: -0.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 140.887 29.4531)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 7.18478,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 146.32 40.834)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.556,
    y1: 34.2832,
    x2: 140.283,
    y2: 39.0101,
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.0472,
    y2: -0.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 162.887 29.4531)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 7.18478,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 168.32 40.834)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.556,
    y1: 34.2832,
    x2: 162.283,
    y2: 39.0101,
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.0472,
    y2: -0.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 84.8867 29.4531)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 7.18478,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 90.3203 40.834)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.5557,
    y1: 34.2832,
    x2: 84.2826,
    y2: 39.0101,
    stroke: "black",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeGroupFooter);
export default __webpack_public_path__ + "static/media/tree-group-footer.36c28a66.svg";
export { ForwardRef as ReactComponent };